import { useEffect, useState, FormEvent } from 'react';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { Article } from '../lib/types';

export type ArticleFormProps = {open: boolean; setOpen: (value: boolean) => void;
  article: Article | null; onSaved: () => void | Promise<void>};

export function useArticleForm({open, setOpen, article, onSaved}: ArticleFormProps) {
  const initialTitle = article?.title || '';
  const initialContent = article?.content || '';
  const initialCategory = article?.category || 'General';
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('General');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!open) return;
    setTitle(initialTitle); setContent(initialContent); setCategory(initialCategory); setError('');
    // Depend on the source article, not edited fields; adding fields would erase typing.
    // React state setters are stable and need not appear in dependencies.
  }, [open, initialTitle, initialContent, initialCategory]);

  const save = async (event: FormEvent) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError('');
    try {
      await api(article ? `/kb/${article.id}` : '/kb', article ? 'PUT' : 'POST', {title, content, category});
      toast.success(article ? 'Article updated.' : 'Article added to your knowledge base.');
      setOpen(false);
      await onSaved();
    } catch (error: any) { setError(error.message); }
    finally { setBusy(false); }
  };
  return {title, setTitle, content, setContent, category, setCategory, busy, error, save};
}